import script from "./ApiApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiApplications.vue?vue&type=script&setup=true&lang=js"

import "./ApiApplications.vue?vue&type=style&index=0&id=95acaaa6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95acaaa6"]])

export default __exports__